import React from 'react';
import { EmptyResult } from '@components';
import { useLingui } from '@lingui/react/macro';

interface TableEmptyTextProps {
    hasActiveFilters?: boolean;
    emptyTitle?: string;
    emptyDescription?: string;
    emptyTitleWhenFiltered?: string;
    emptyDescWhenFiltered?: string;
}

export const TableEmptyOrFilteredText: React.FC<TableEmptyTextProps> = ({
    emptyTitle,
    emptyDescription,
    emptyTitleWhenFiltered,
    emptyDescWhenFiltered,
    hasActiveFilters = false,
}) => {
    const { t } = useLingui();

    const title = hasActiveFilters
        ? (emptyTitleWhenFiltered ?? t`No records found`)
        : (emptyTitle ?? t`No records yet`);

    const description = hasActiveFilters
        ? (emptyDescWhenFiltered ?? t`Your search didn't match any results.`)
        : (emptyDescription ?? t`Your content will appear here.`);

    return <EmptyResult bgColor="transparent" title={title} description={description} />;
};
